import { Component, Input, OnInit } from "@angular/core";

import { AuthService } from "../../../../services/auth.service";
import { ReportableService } from "../../../../services/reportable.service";
import { Router, ActivatedRoute } from "@angular/router";

import { saveAs as importedSaveAs } from "file-saver";

import { Page } from "../../../../models/paging/page";
import { StockLevelLocationService } from "../../../../services/stock-level-location.service";
import { Model } from "@swimlane/ngx-datatable";
import { ColumnService } from "../../../../services/ColumnService";

@Component({
  selector: "app-stock-level-location",
  templateUrl: "./stock-level-location.component.html",
  styleUrls: ["./stock-level-location.component.css"],
})
export class StockLevelLocationComponent implements OnInit {
  @Input() location_Id: string;
  @Input() product_Type_Id: string;
  @Input() cyl_Size_Id: string;

  page = new Page();
  rows = Array<any>();
  init: boolean;

  filter: any = {
    quick_Search: "",
  };

  client;

  availableOptions: string[] = [
    "Serial Number",
    "Material",
    "Product Type",
    "Size",
    "In Service",
    "Company",
    "Tag",
    "Location",
  ];

  selectedOptions: string[] = [
    "Serial Number",
    "Material",
    "Product Type",
    "Size",
    "In Service",
    "Company",
    "Tag",
    "Location",
  ];

  location: string;
  company: string;

  constructor(
    authService: AuthService,
    public stockLevelLocation: StockLevelLocationService,
    public reportableService: ReportableService,
    public router: Router,
    private route: ActivatedRoute,
    private columnService: ColumnService
  ) {
    this.client = authService.currentUser.value;
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = "desc";
    this.page.sortBy = "";
  }

  ngOnInit() {
    this.getcolumns();

    if (this.location_Id != undefined) {
      this.loadTable();
      this.init = true;
    }
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == "") {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable();
  }

  loadTable() {
    this.stockLevelLocation
      .getResults(
        this.page,
        parseInt(this.location_Id),
        parseInt(this.product_Type_Id),
        parseInt(this.cyl_Size_Id),
        this.filter.quick_Search
      )
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
        this.location = this.rows[0].address_1;
        this.company = this.rows[0].companyName;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  downloadReport(id: number) {
    console.log("Downloading Report | ID: " + id);
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, "Delivery Notes.pdf");
    });
  }

  generateExcel() {
    this.stockLevelLocation
      .getExcel(
        parseInt(this.location_Id),
        parseInt(this.product_Type_Id),
        parseInt(this.cyl_Size_Id)
      )
      .then((data) => {
        importedSaveAs(data, "Stock_Level_Location_" + this.location + ".xlsx");
      });
  }

  gotoTop() {
    let top = document.getElementById("top");
    if (top !== null) {
      top.scrollIntoView(true);
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "stockLevelLocation").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "stockLevelLocation", this.selectedOptions).then((data) => {
    });
  }
}
